export const HLS = 'hls'
